import { render } from "./NetworkEdit.vue?vue&type=template&id=7e54a048&ts=true"
import script from "./NetworkEdit.vue?vue&type=script&lang=ts"
export * from "./NetworkEdit.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/thelounge/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__